import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../components/Sidebar";
import { products, more_products, GANESH_SEASON_ENABLED, DIWALI_SEASON_ENABLED } from "../../data/Data";
import { getActiveSeason, getProductSeason } from "../../config/seasons";
import { category as categoryList } from "../../data/Data";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Heading from "../../common/Heading";
import { useDispatch } from "react-redux";
import { addToCart, getCartTotal } from "../../redux/CartSlice";
import { analytics, auth } from "../../config/firebase";
import checkUserSignedIn from "../../util/AuthUtil";
import { useNavigate } from "react-router-dom";
import ProceedToCheckoutView from "../../components/ProceedToCheckoutView";
import { logEvent } from "firebase/analytics";
import ScrollToTop from "../../components/ScrollToTop";
import Seo from "../../components/Seo";
import { routeMeta } from "../../seo/staticRoutes";
import { CATEGORY_BY_SLUG } from "../../seo/categories";
import "./shop.css"



export default function Shop() {
  const all_products = [...products, ...more_products].filter(
    (item) =>
      (!item.isGaneshSeasonal || GANESH_SEASON_ENABLED) &&
      (!item.isDiwaliSeasonal || DIWALI_SEASON_ENABLED)
  );
  const [filterArray, setFilterArray] = useState([]);
  const [filterArrayRange, setFilterArrayRange] = useState([]);
  const [filterArrayWeight, setFilterArrayWeight] = useState([]);
  const [authUser, setAuthUser] = useState(null);

  // const [filteredUsers, setFilteredUsers] = useState(all_products);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [qty, setQty] = useState(1);
  const handleAddToCart = (item) => {
    console.log(item);
    let totalPrice = qty * item.price;
    const tempProduct = {
      ...item,
      quantity: qty,
      totalPrice,
    };
    dispatch(addToCart(tempProduct));
    dispatch(getCartTotal());
  };
useEffect(()=>{
  logEvent(analytics,`User reached shop page`)
    checkUserSignedIn(auth,setAuthUser)
},[])

  /**
   * Filters are a desktop-only feature.
   *
   * Below 992px the sidebar has no room to sit beside the grid, so shop.css
   * turns it into a fixed full-viewport drawer — which means opening it hides
   * the entire catalogue behind a wall of checkboxes and an autoplaying video,
   * with no sense of what you're filtering. Phones get the plain product grid
   * instead; sort and the category chips still work, and category browsing
   * comes in through ?category= from the header menu.
   *
   * Gating on state rather than CSS keeps the sidebar — and its video — out of
   * the DOM entirely on mobile instead of merely hidden.
   */
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window === "undefined" || window.innerWidth > 992
  );

  useEffect(() => {
    const syncViewport = () => setIsDesktop(window.innerWidth > 992);
    window.addEventListener("resize", syncViewport);
    return () => window.removeEventListener("resize", syncViewport);
  }, []);


  // useEffect(()=>{
  //   checkUserSignedIn(auth,setAuthUser)
  //   if(!authUser)
  //     navigate("/login");
  // },[authUser])

  

  // Category navigation, driven by ?category= from the Browse Categories menu.
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCategorySlug = searchParams.get("category");
  const activeCategory = categoryList.find((c) => c.slug === activeCategorySlug);

  const filteredUsers = useMemo(() => {
    const byFilters = all_products.filter(filteration);
    if (!activeCategorySlug) return byFilters;
    return byFilters.filter((item) => item.category === activeCategorySlug);
  }, [
    all_products,
    filterArray,
    filterArrayRange,
    filterArrayWeight,
    activeCategorySlug,
  ]);

  const clearCategory = () => {
    searchParams.delete("category");
    searchParams.delete("format");
    setSearchParams(searchParams);
  };

  const onFilterChange = (evt, filter, typeIndex) => {
    switch (typeIndex.id) {
      case 1:
        {
          if (evt.target.checked)
            setFilterArray([...filterArray, filter.variety]);
          else
            setFilterArray((filterArray) =>
              filterArray.filter(function (item) {
                return item !== filter.variety;
              })
            );
        }
        break;
      case 2 :
        {
          if (evt.target.checked) {
            setFilterArrayRange([...filterArrayRange, filter.variety]);
          } else {
            setFilterArrayRange((filterArrayRange) =>
              filterArrayRange.filter(function (item) {
                return item !== filter.variety;
              })
            );
          }
        }
        break;
      case 3: {
        if (evt.target.checked)
          setFilterArrayWeight([...filterArrayWeight, filter.variety]);
        else
          setFilterArrayWeight((filterArrayWeight) =>
            filterArrayWeight.filter(function (item) {
              return item !== filter.variety;
            })
          );
      }
    }
  };

  function filteration(item) {
    if (
      !filterArray.length &&
      !filterArrayRange.length &&
      !filterArrayWeight.length
    ) {
      return true;
    } else {
      if (filterArray.length) {
        return nameCheck(item);
      } else if (filterArrayRange.length) {
        return rangeCheck(item);
      } else {
        return weightCheck(item);
      }
    }
  }

  function rangeCheck(item) {
    return filterArrayRange.find(function (eachKey) {
      if (priceWithInRange(item.price, eachKey)) {
        if (filterArrayWeight.length) return weightCheck(item);
        else return true;
      }
    });
  }

  function weightCheck(item) {
    return filterArrayWeight.find(function (eachKey) {
      return weightWithInRange(item.weight, eachKey);
    });
  }

  function weightWithInRange(weight, range) {
    console.log(weight + "---weight----" + range);
    return parseInt(weight) < parseInt(range);
  }

  function priceWithInRange(price, range) {
    console.log(price + "---price----" + range);
    let rangeArr = range.split("-");
    if (price >= parseInt(rangeArr[0]) && price < parseInt(rangeArr[1]))
      return true;
    else return false;
  }

  function nameCheck(item) {
    return filterArray.find(function (eachKey) {
      if (item.product_name.toLowerCase().includes(eachKey.toLowerCase())) {
        if (filterArrayRange.length) return rangeCheck(item);
        else if (filterArrayWeight.length) return weightCheck(item);
        else return true;
      }
    });
  }

  const [viewMode, setViewMode] = useState('grid');
  const [sortBy, setSortBy] = useState('featured');
  // Desktop only — see the isDesktop note above.
  const [showFilters, setShowFilters] = useState(true);
  const [likedProducts, setLikedProducts] = useState({});
  const [imageLoading, setImageLoading] = useState({});

  const handleLikeClick = (e, productId) => {
    e.stopPropagation();
    setLikedProducts(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const handleImageLoad = (productId) => {
    setImageLoading(prev => ({
      ...prev,
      [productId]: false
    }));
  };

  const handleImageStart = (productId) => {
    setImageLoading(prev => ({
      ...prev,
      [productId]: true
    }));
  };

  const calculateDiscount = (price, mainPrice) => {
    const mrp = Number(mainPrice);
    const now = Number(price);
    if (!mrp || mrp <= now) return null;
    return Math.round(((mrp - now) / mrp) * 100);
  };

  const sortProducts = (products) => {
    switch (sortBy) {
      case 'price-low':
        return [...products].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      case 'price-high':
        return [...products].sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
      case 'name':
        return [...products].sort((a, b) => a.product_name.localeCompare(b.product_name));
      default:
        return products;
    }
  };

  const sortedProducts = sortProducts(filteredUsers);

  // Festival merchandising: while a season is running, its products lead the page
  // in their own collection band, and the everyday range continues below — so the
  // seasonal push never buries the core catalogue.
  const activeSeason = getActiveSeason();
  const hasActiveFilters =
    filterArray.length + filterArrayRange.length + filterArrayWeight.length > 0;

  const seasonalProducts = activeSeason
    ? sortedProducts.filter((item) => getProductSeason(item) === activeSeason.key)
    : [];
  const everydayProducts = activeSeason
    ? sortedProducts.filter((item) => getProductSeason(item) !== activeSeason.key)
    : sortedProducts;

  // When the shopper is filtering, a split view hides matches — show one flat grid.
  const showSeasonalBand =
    Boolean(activeSeason) && !hasActiveFilters && seasonalProducts.length > 0;

  const renderProductCard = (item, index) => {
    const discount = calculateDiscount(item.price, item.mainPrice);
    const isLiked = likedProducts[item.id];
    const isImageLoading = imageLoading[item.id];

    return (
      <div className={`product-card-wrapper ${viewMode}`} key={item.product_name_key || index}>
        <div
          className="modern-product-card shop-product-card"
          onClick={() => navigate(`/item/${item.product_name_key}`)}
        >
          {discount && <div className="discount-badge">-{discount}%</div>}

          <div className="product-image-container">
            {isImageLoading && <div className="skeleton-image"></div>}

            <img
              src={item.product_img}
              alt={item.product_name}
              loading="lazy"
              onLoadStart={() => handleImageStart(item.id)}
              onLoad={() => handleImageLoad(item.id)}
              style={{ display: isImageLoading ? "none" : "block" }}
            />

            <div className="product-overlay"></div>

            {!item.out_of_stock && (
              <div className="product-actions">
                <button
                  className="action-btn cart-btn min-width60"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToCart(item);
                  }}
                  title="Add to Cart"
                >
                  <i className="fa fa-shopping-cart"></i>
                </button>
                <button
                  className="action-btn wishlist-btn min-width60"
                  onClick={(e) => handleLikeClick(e, item.id)}
                  title="Add to Wishlist"
                >
                  <svg
                    className={`heart-like ${isLiked ? "liked" : ""}`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                  </svg>
                </button>
              </div>
            )}

            {item.out_of_stock && (
              <div className="out-of-stock-overlay">
                <div className="out-of-stock-text">Out of Stock</div>
              </div>
            )}
          </div>

          <div className="product-info">
            <h4 className="product-title">{item.product_name}</h4>

            <div className="product-price-container">
              <span className="current-price">₹{item.price}</span>
              {Number(item.mainPrice) > Number(item.price) && (
                <span className="original-price">₹{item.mainPrice}</span>
              )}
            </div>

            {viewMode === "list" && (
              <div className="product-description">
                <p>
                  {item.description ||
                    "Premium quality incense stick with natural ingredients for a divine experience."}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // A category we advertise but don't yet stock online deserves an honest
  // message and a route onward, not a generic "no results" dead end.
  const emptyState = activeCategory ? (
    <div className="no-products">
      <div className="no-products-content">
        <i className="fas fa-seedling"></i>
        <h3>{activeCategory.category_name} — coming online soon</h3>
        <p>
          We make {activeCategory.category_name.toLowerCase()} at our Indore factory, but
          they aren't listed for online ordering yet. Message us on WhatsApp and we'll
          take your order directly, or ask about bulk pricing.
        </p>
        <div className="empty-actions">
          <a
            className="clear-filters-btn"
            href="https://api.whatsapp.com/send?phone=916264208349&text=Hi%20NT%20Sticks%2C%20I%27d%20like%20to%20order%20"
            target="_blank"
            rel="noreferrer"
          >
            Ask on WhatsApp
          </a>
          <button className="clear-filters-btn secondary" onClick={clearCategory}>
            Browse everything
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className="no-products">
      <div className="no-products-content">
        <i className="fas fa-search"></i>
        <h3>No Products Found</h3>
        <p>Try adjusting your filters or search criteria</p>
        <button
          className="clear-filters-btn"
          onClick={() => {
            setFilterArray([]);
            setFilterArrayRange([]);
            setFilterArrayWeight([]);
          }}
        >
          Clear All Filters
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Page-level, and deliberately not inside renderProductCard. Mounted per
          card it rendered 32 identical copies of the same tags — and mounted
          none at all when a filter matched nothing, leaving /shop with no
          canonical exactly when it most needed one. */}
      <Seo
        {...routeMeta("/shop")}
        /* A filtered view of /shop is the same catalogue in a different order,
           so it points at the category's own page as the version to index. */
        canonicalPath={
          activeCategorySlug && CATEGORY_BY_SLUG[activeCategorySlug]
            ? CATEGORY_BY_SLUG[activeCategorySlug].path
            : undefined
        }
      />
      <div className="modern-shop-container">
        {/* Shop Header */}
        <div className="shop-header">
          <div className="container-fluid">
            <div className="row px-xl-5">
              <div className="col-12">
                <div className="shop-breadcrumb">
                  <Link to="/" className="breadcrumb-link">Home</Link>
                  <i className="fas fa-chevron-right"></i>
                  <span className="breadcrumb-current">Shop</span>
                </div>
                <div className="shop-title-section">
                  <h1 className="shop-title">
                    {activeCategory ? activeCategory.category_name : "Our Products"}
                  </h1>
                  <p className="shop-subtitle">
                    {activeCategory
                      ? activeCategory.quantity
                      : "Discover our complete collection of premium incense sticks and spiritual essentials"}
                  </p>
                  {activeCategory && (
                    <button className="category-clear-chip" onClick={clearCategory}>
                      {activeCategory.category_name}
                      <i className="fas fa-times ml-2"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Shop Controls */}
        <div className="shop-controls">
          <div className="container-fluid">
            <div className="row px-xl-5">
              <div className="col-12">
                <div className="controls-wrapper">
                  <div className="controls-left">
                    {isDesktop && (
                      <button
                        className="filter-toggle-btn"
                        onClick={() => setShowFilters(!showFilters)}
                      >
                        <i className="fas fa-filter"></i>
                        <span>Filters</span>
                        {(filterArray.length + filterArrayRange.length + filterArrayWeight.length) > 0 && (
                          <span className="filter-count">
                            {filterArray.length + filterArrayRange.length + filterArrayWeight.length}
                          </span>
                        )}
                      </button>
                    )}
                    <div className="results-count">
                      <span>{sortedProducts.length} Products Found</span>
                    </div>
                  </div>
                  
                  <div className="controls-right">
                    <div className="view-mode-toggle">
                      <button 
                        className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                        onClick={() => setViewMode('grid')}
                      >
                        <i className="fas fa-th-large"></i>
                      </button>
                      <button 
                        className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                        onClick={() => setViewMode('list')}
                      >
                        <i className="fas fa-list"></i>
                      </button>
                    </div>
                    
                    <div className="sort-dropdown">
                      <select 
                        value={sortBy} 
                        onChange={(e) => setSortBy(e.target.value)}
                        className="sort-select"
                      >
                        <option value="featured">Featured</option>
                        <option value="price-low">Price: Low to High</option>
                        <option value="price-high">Price: High to Low</option>
                        <option value="name">Name: A to Z</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="shop-content">
          <div className="container-fluid">
            <div className="row px-xl-5">
              {/* Sidebar — desktop only */}
              {isDesktop && (
                <Sidebar
                  onFilterChange={(evt, filter, typeIndex) =>
                    onFilterChange(evt, filter, typeIndex)
                  }
                  showFilters={showFilters}
                  onToggleFilters={() => setShowFilters(false)}
                  visibleProducts={all_products}
                />
              )}

              {/* Products Grid.
                  col-12 below lg so the grid spans the row once the sidebar is
                  gone — col-md-8 used to leave a third of the tablet row empty. */}
              <div
                className={`col-12 col-lg-9 ${
                  isDesktop && !showFilters ? "full-width" : ""
                }`}
              >
                <div className="products-section">
                  {sortedProducts.length === 0 && emptyState}

                  {sortedProducts.length > 0 && showSeasonalBand && (
                    <>
                      <section className="season-collection">
                        <div className="season-collection-head">
                          <span className="season-collection-badge">
                            <i className="fas fa-om"></i>
                            {activeSeason.badge}
                          </span>
                          <h2>{activeSeason.collectionTitle}</h2>
                          <p>{activeSeason.collectionBlurb}</p>
                        </div>
                        <div
                          className={`products-grid ${
                            viewMode === "list" ? "list-view" : "grid-view"
                          }`}
                        >
                          {seasonalProducts.map(renderProductCard)}
                        </div>
                      </section>

                      {everydayProducts.length > 0 && (
                        <section className="everyday-collection">
                          <div className="everyday-collection-head">
                            <h2>Our Everyday Range</h2>
                            <p>
                              Incense sticks, dhoop, cones and sambrani cups — made fresh at our
                              Indore factory all year round.
                            </p>
                          </div>
                          <div
                            className={`products-grid ${
                              viewMode === "list" ? "list-view" : "grid-view"
                            }`}
                          >
                            {everydayProducts.map(renderProductCard)}
                          </div>
                        </section>
                      )}
                    </>
                  )}

                  {sortedProducts.length > 0 && !showSeasonalBand && (
                    <div
                      className={`products-grid ${
                        viewMode === "list" ? "list-view" : "grid-view"
                      }`}
                    >
                      {sortedProducts.map(renderProductCard)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <ProceedToCheckoutView/>
      <ScrollToTop />
    </>
  );
}
